import Stack from 'app/components/base/Stack'
import { useGetHelpCenterCategories } from 'app/services/Query/help-center/help-center.query'
import { HELP_CENTER_MAIN_CATEGORIES_PLACEHOLDER } from 'app/utils/constants/help-center.constants'

import HelpCenterCategoriesCollapse from './components/HelpCenterCategoriesCollapse'
import HelpCenterCollapseCard from './components/HelpCenterCollapseCard'
import HelpCenterLinkCard from './components/HelpCenterLinkCard'

interface HelpCenterLeftMenuFeatureProps {
  categorySlug: string
  isLoading: boolean
}

const HelpCenterLeftMenuFeature = ({
  categorySlug,
  isLoading
}: HelpCenterLeftMenuFeatureProps) => {
  const { data: categories } = useGetHelpCenterCategories({
    params: { needSubCategories: true },
    options: {
      enabled: false,
      placeholderData: HELP_CENTER_MAIN_CATEGORIES_PLACEHOLDER.slice(0, 6)
    }
  })

  return (
    <Stack
      direction="column"
      spacing={2}
      sx={{ width: { xs: '100%', md: 230 } }}
    >
      <HelpCenterCategoriesCollapse open>
        {categories?.map((item, index) => {
          const key = item.id
          const subcategorySlug = item?.sub_categories?.find(
            (el) => el.slug === categorySlug
          )?.slug
          const isActiveCategory =
            item.slug === categorySlug || !!subcategorySlug
          const hasSubcategories = Number(item?.sub_categories?.length) > 0
          const isLastItem = index === categories?.length - 1

          if (!hasSubcategories) {
            return (
              <HelpCenterLinkCard
                key={key}
                categoryName={item.name}
                categorySlug={item.slug}
                isActiveCategory={isActiveCategory}
                hideBorderBottom={isLastItem}
                isLoading={isLoading}
              />
            )
          }

          return (
            <HelpCenterCollapseCard
              key={key}
              categoryName={item.name}
              subcategories={item.sub_categories}
              subcategorySlug={subcategorySlug}
              isActiveCategory={isActiveCategory}
              hideBorderBottom={isLastItem}
              isLoading={isLoading}
            />
          )
        })}
      </HelpCenterCategoriesCollapse>
    </Stack>
  )
}

export default HelpCenterLeftMenuFeature
